class CollectionGridManager {
  constructor() {
    // Collection heading elements
    this.catSwitcherMenu = document.querySelector(".CAT-header__nav-list");
    this.catSwitcherMenuTabs = this.catSwitcherMenu?.querySelectorAll(".CAT-header__nav-link");
    this.customTabs = this.catSwitcherMenu?.closest('.custom-tabs');

    // Infinite scroll properties
    this.pageNr = 1;
    this.CAT_collection_grid_template_id = document.querySelector('#product-grid')?.dataset.id;
    this.isFetching = false;
    this.UTMproductsRearenged = false;

    this.init();
  }

  init() {
    this.triggerSearchPopup();
    this.initInfiniteScroll();
    this.setupInitialFilters();
    this.setupReviewHandlers();
    this.handleStickyFilterButton();
    this.updateBodyCollectionClass(this.getCurrentCollectionHandleFromPath());
    this.collectionSwitcherMenuHandler();
  }

  getCurrentCollectionHandleFromPath() {
    const pathParts = window.location.pathname.split('/').filter(Boolean);
    const collectionIndex = pathParts.indexOf('collections');
    if (collectionIndex === -1 || !pathParts[collectionIndex + 1]) return '';
    return pathParts[collectionIndex + 1];
  }

  updateBodyCollectionClass(handle) {
    if (!handle || !document.body) return;

    const existingCollectionClasses = Array.from(document.body.classList).filter((className) => className.startsWith('collection__'));
    existingCollectionClasses.forEach((className) => document.body.classList.remove(className));

    document.body.classList.add(`collection__${handle}`);
  }

  // Search functionality
  triggerSearchPopup() {
    const headerSearchButton = document.querySelector('.CAT-header__search-action .search-button');
    const headerSearchPopup = document.querySelector('.header__search details');

    if (!headerSearchButton) return;

    headerSearchButton.addEventListener('click', () => {
      if (headerSearchPopup) {
        headerSearchPopup.open = true;
        const searchInput = headerSearchPopup.querySelector('input[type="search"]');
        if (searchInput) {
          searchInput.focus();
        }
      }
    });
  }

  // Collection switcher menu handler
  collectionSwitcherMenuHandler() {
    if (!this.catSwitcherMenuTabs) return;

    this.catSwitcherMenuTabs.forEach((catSwitcherMenuTab, index) => {
      catSwitcherMenuTab.addEventListener('click', (event) => {
        const target = event.currentTarget;

        this.catSwitcherMenuTabs.forEach(tab => tab.classList.remove('active'));
        target.classList.add('active');

        // Bring the newly active tab into view if it's off-screen (mobile horizontal scroll)
        if (typeof autoScrollToCATNavlink === 'function') autoScrollToCATNavlink();

        // SEO - Update Collection Title
        document.title = target.dataset.collectionTitle;

        let handle = target.dataset.handle;
        this.updateBodyCollectionClass(handle);
        if (window.location.pathname.split('/').includes(handle)) return;

        const productGridId = document.querySelector('.product-grid-wrapper').id;
        this.fetchCollectionCategorie(productGridId, handle);

        // Hide low reviews widgets after content is loaded
        setTimeout(hideLowReviewWidgets, 1000);
      });
    });
  }

  // Fetch collection categories (from CollectionHeadingManager)
  fetchCollectionCategorie(sectionId, colectionHandle) {
    let fetchUrl;
    let url;

    //fetch for products collections change
    let query_params = window.location.search.replace("?", "");

    //format query params
    if (query_params == '') {
      query_params = query_params.slice(0, query_params.indexOf('section_id=')) + query_params.slice(query_params.indexOf('&', query_params.indexOf('section_id=')) + 1);
    }
    let path = window.location.href.slice(0, window.location.href.lastIndexOf('/'));
    let new_path = window.location.pathname;

    if (new_path.split('/').length == 4 && !colectionHandle.includes('dossier-originals')) {
      let updated_path = new_path.split('/');
      updated_path[updated_path.length - 2] = colectionHandle;
      updated_path = updated_path.join('/');
      path = `${updated_path}`;

      fetchUrl = `${path}?section_id=${sectionId}&${query_params}`;
      url = `${path}${query_params != '' ? '?' : ''}${query_params}`;
    } else {
      if (colectionHandle.includes('dossier-originals')) {
        fetchUrl = `${window.location.origin}/collections/${colectionHandle}?section_id=${sectionId}`;
        url = `${window.location.origin}/collections/${colectionHandle}`;

        extraFiltersSettings.closeFilter();
      } else {
        fetchUrl = `${path}/${colectionHandle}?section_id=${sectionId}&${query_params}`;
        url = `${path}/${colectionHandle}${query_params != '' ? '?' : ''}${query_params}`;
      }
    }

    // Update url
    window.history.pushState("", "", url);

    // Add loading to container
    document.querySelector('.collection').classList.add('loading');

    fetch(fetchUrl)
      .then(response => response.text())
      .then((response) => {
        const section_id = `#${sectionId}`;
        this.renderNewItems(section_id, response);

        // Remove loading
        document.querySelector('.collection').classList.remove('loading');
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }

  // Render new items (from CollectionHeadingManager)
  renderNewItems(section, html) {
    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');

    const newEmptyResults = parsedHtml.querySelector('.no-results');

    const newSection = parsedHtml.querySelector(section);
    const currentSection = document.querySelector(section);

    if (newSection && currentSection) {
      currentSection.innerHTML = newSection.innerHTML;

      const newProductGrid = parsedHtml.querySelector('#product-grid');
      const currentProductGrid = document.querySelector('#product-grid');

      if (!newProductGrid || !currentProductGrid) return;
      currentProductGrid.classList.add('pageOne');
      currentProductGrid.dataset.pages = newProductGrid.dataset.pages;

      // Add Filters Functionality
      extraFiltersSettings.init();

      if (newEmptyResults) return;

      // Update product reviews widgets
      if (typeof yotpoWidgetsContainer !== 'undefined' && typeof yotpoWidgetsContainer.initWidgets === 'function') {
        yotpoWidgetsContainer.initWidgets();
      }

      setTimeout(() => {
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        if (typeof initializeScrollZoomAnimationTrigger === 'function') initializeScrollZoomAnimationTrigger(html.innerHTML);
      }, 10);

      showDynamicPrices();

      // Handle sticky filter button
      this.handleStickyFilterButton();

      // Open search popup
      this.triggerSearchPopup();

      if (window.location.href.includes('/dossier-originals')) {
        // init dossier originals CAT page logic
        promoInfoBoxLogic()
        VideoLogicInit();
      }
    }
  }

  // Infinite scroll initialization
  initInfiniteScroll() {
    document.addEventListener("scroll", () => {
      this.infiniteScrollRender();
    });
  }

  // Setup initial filters and UTM products
  setupInitialFilters() {
    setTimeout(() => {
      this.utmProductsFilter();
    }, 200);
  }

  // Setup review-related handlers
  setupReviewHandlers() {
    setTimeout(() => {
      hideLowReviewWidgets();
    }, 1000);
  }

  // Fetch new category items
  async fetchNewCatItems(sectionId, page_nr, target_element, forUTMproduct = false) {
    let query_params = window.location.search.replace("?", "");
    let page_query = `page=${page_nr}`;
    let url = `${window.location.pathname}?section_id=${sectionId}&${query_params}&${page_query}`;

    this.isFetching = true;
    let response = await fetch(url);
    let results = await response.text();
    this.isFetching = false;

    if (forUTMproduct) {
      this.renderNewCATitemsForUTM(target_element, results);
    } else {
      this.renderNewCatItems(target_element, results);
    }

    if (typeof yotpoWidgetsContainer !== 'undefined' && typeof yotpoWidgetsContainer.initWidgets === 'function') {
      yotpoWidgetsContainer.initWidgets();
    }
  }

  // Render new items for UTM products
  renderNewCATitemsForUTM(target, html) {
    const newHTML = new DOMParser().parseFromString(html, 'text/html');

    if (newHTML.querySelector('.no-results')) return;

    const currentUrl = window.location.search;
    const urlSearchParams = new URLSearchParams(currentUrl);

    if (!urlSearchParams.has('utm_products')) return;

    const utmProductsValue = urlSearchParams.get('utm_products');

    if (!utmProductsValue) return;

    let arrProducts = utmProductsValue.split("_").filter(Boolean);

    const targetElement = document.querySelector(target);
    if (!targetElement) return;

    arrProducts.forEach(el => {
      const productElement = newHTML.querySelector(`#${el}`);

      if (productElement) {
        const productGridItem = productElement.closest('.grid__item');
        if (productGridItem) {
          targetElement.appendChild(productGridItem);
          showDynamicPrices();
        }
      }
    });
  }

  // Render new category items
  renderNewCatItems(target, html) {
    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
  
    if (parsedHtml.querySelector('.no-results')) return;
  
    parsedHtml.querySelectorAll('.promo-card').forEach(el => el.remove());
  
    const container = document.querySelector(target);
    const newContainer = parsedHtml.querySelector(target);
  
    if (!container || !newContainer) return;
  
    const newItems = Array.from(newContainer.children);
    container.append(...newItems);

    // Reveal the newly appended items right away instead of letting the
    // intersection observer re-hide below-the-fold items and delay them.
    newItems.forEach((item) => {
      item.classList.remove('scroll-trigger--offscreen');
      item.querySelectorAll('.scroll-trigger--offscreen').forEach((el) => el.classList.remove('scroll-trigger--offscreen'));
    });

    requestAnimationFrame(() => {
      if (typeof initializeScrollZoomAnimationTrigger === 'function') {
        initializeScrollZoomAnimationTrigger();
      }
    });
  
    if (this.UTMproductsRearenged) {
      this.removeDuplicateProducts();
    }
  }

  // Extract duplicate removal logic into separate method
  removeDuplicateProducts() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const utmProductsValue = urlSearchParams.get('utm_products');
    let arrProducts = utmProductsValue.split("_");

    arrProducts.forEach(el => {
      let arrayDublicatedProducts = document.querySelectorAll(`#product-grid #${el}`);
      if (arrayDublicatedProducts.length > 1) {
        for (let i = 1; i <= arrayDublicatedProducts.length - 1; i++) {
          arrayDublicatedProducts[i].closest('.grid__item').remove();
        }
      }
    });
  }

  // Handle infinite scroll rendering
  async infiniteScrollRender() {
    let productGrid = document.querySelector('#product-grid');
    let currentPagesNr = productGrid.dataset.pages;

    if (productGrid.classList.contains('pageOne')) {
      this.pageNr = 1;
      productGrid.classList.remove('pageOne');
    }

    let viewportHeight = window.innerHeight;
    let scrollY = window.scrollY;

    let productItems = productGrid.querySelectorAll('.grid__item');
    let lastItem = productItems[productItems.length - 1];

    if (!lastItem) return;

    const rect = lastItem.getBoundingClientRect();
    const lastItemPositionInViewport = rect.top + scrollY;

    // Start fetching the next page before the shopper actually reaches the last
    // product, so the new items are usually ready by the time they get there and
    // the grid feels seamless instead of pausing at the bottom. Prefetching ~1.5
    // viewports early hides the network round-trip.
    const preloadOffset = viewportHeight * 1.5;

    if (scrollY + viewportHeight + preloadOffset >= lastItemPositionInViewport) {
      if (this.pageNr < currentPagesNr && this.isFetching == false) {
        this.pageNr++;
        await this.fetchNewCatItems(this.CAT_collection_grid_template_id, this.pageNr, '#product-grid');
        showDynamicPrices();
      }
    }

    this.offScreenAnimationFix();
  }

  // UTM products filtering
  async utmProductsFilter() {
    const currentUrl = window.location.search;
    const urlSearchParams = new URLSearchParams(currentUrl);

    if (!urlSearchParams.has('utm_products')) {
      return;
    }

    const utmProductsValue = urlSearchParams.get('utm_products');

    if (document.querySelector('#product-grid').dataset.pages > 1) {
      for (let i = 2; i <= document.querySelector('#product-grid').dataset.pages; i++) {
        await this.fetchNewCatItems(this.CAT_collection_grid_template_id, this.pageNr + 1, '#product-grid', true);
        this.pageNr++;
      }
    }

    let arrProducts = utmProductsValue.split("_");
    let ul = document.querySelector("#product-grid");
    let itemsToMove = [];

    arrProducts.forEach(el => {
      for (let i = 0; i < ul.children.length; i++) {
        if (ul.children[i].children[0]?.id == el) {
          itemsToMove.push(ul.children[i]);
          break;
        }
      }
    });

    let itemsToMoveR = itemsToMove.reverse(); // reverse array to show correct order
    itemsToMoveR.forEach(item => {
      ul.removeChild(item); // Remove from current position
      ul.insertBefore(item, ul.firstElementChild); // Insert at the beginning
    });

    this.pageNr = 1;
    this.UTMproductsRearenged = true;
  }

  // Fix off-screen animations
  offScreenAnimationFix() {
    let container = document.querySelector("#product-grid.grid--custom");
    if (!container) return;

    const isElementInViewport = (element) => {
      if (!element) return false;
      const rect = element.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      return (
        rect.top < viewportHeight &&
        rect.bottom > 0 &&
        rect.left < viewportWidth &&
        rect.right > 0
      );
    };

    container.querySelectorAll('.scroll-trigger--offscreen').forEach(el => {
      if (isElementInViewport(el)) {
        el.classList.remove('scroll-trigger--offscreen');
      }
    });

    this.handleYotpoReviews();
  }

  // Extract Yotpo review handling into separate method
  handleYotpoReviews() {
    document.querySelectorAll('#product-grid .card--standard').forEach(el => {
      let yotpoText = el.querySelector('.yotpo-sr-bottom-line-text');
      if (yotpoText) {
        let reviewText = yotpoText.innerHTML;
        let reviewNumber = parseFloat(reviewText.match(/\d+(\.\d+)?/));

        if (!isNaN(reviewNumber)) {
          if (reviewNumber < 5) {
            let yotpoWidget = yotpoText.closest('.yotpo-widget-instance');
            if (yotpoWidget) {
              yotpoWidget.style.display = 'none';
            }
          }
        }
      }
    });
  }

  handleStickyFilterButton() {
    const button = document.querySelector(".CAT-header__filters-action");
    if (!button) return;

    const parent = button.parentElement;
    const headerHeight = 111; // px
    const buttonOffsetTop = button.getBoundingClientRect().top + window.scrollY;

    // Function to store the current width in a data attribute
    const updateParentWidth = () => {
      parent.style.setProperty("--sticky-width", `${button.offsetWidth}px`);
    };

    // Set initial width
    updateParentWidth();

    // Observe width changes with ResizeObserver
    const resizeObserver = new ResizeObserver(updateParentWidth);
    resizeObserver.observe(button);

    // Optional: also update width on button click if toggle changes size
    button.addEventListener("click", () => {
      setTimeout(updateParentWidth, 50); // slight delay to allow DOM changes
    });

    // Scroll handling for sticky class
    window.addEventListener("scroll", () => {
      if (window.innerWidth > 990) {
        if (window.scrollY > buttonOffsetTop - headerHeight) {
          parent.classList.add("filters-sticky");
        } else {
          parent.classList.remove("filters-sticky");
        }
      }
    });
  }
}

// Single DOMContentLoaded event listener
document.addEventListener("DOMContentLoaded", () => {
  const collectionGridManager = new CollectionGridManager();
});